import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router/index.js'
Vue.use(VueAxios, axios);

Vue.config.productionTip = false
let api_url="https://apitest.data-viz.cn";
let http_url='https://test.hanabi.cn';
if(window.location.origin.indexOf('activity.hanabi.cn')>-1||
	window.location.origin.indexOf('a.hanabi.cn')>-1){
  api_url="https://api.data-viz.cn";
  http_url='https://hanabi.cn';
} 
localStorage.apiUrl=api_url;
localStorage.httpUrl=http_url;
new Vue({
  render: h => h(App),
  router
}).$mount('#app')
